import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import {
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";

import { AppSearchFieldProps } from "./types";

const AppSearchField = ({
  value,
  placeholder = "Search...",
  fullWidth = false,
  onChange,
}: AppSearchFieldProps) => {
  return (
    <TextField
      size="small"
      value={value}
      fullWidth={fullWidth}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        minWidth: { xs: "100%", sm: 300 },
        "& .MuiOutlinedInput-root": {
          bgcolor: "background.paper",
          borderRadius: 1.5,
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),

        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => onChange("")}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  );
};

export default AppSearchField;
